import React from 'react'
import HeroSection from './HomeMaintenance/HeroSection'
import InfoSection from './InfoSection'
import HomeMaintenanceFeatures from './HomeMaintenance/HomeMaintenanceFeatures'
import ReviewBoostSection from './ReviewBoostSection'
import { useNavigate } from 'react-router-dom'

function HomeMaintenancePage() {
  const navigate = useNavigate();

  const handleHeroSubmit = (email) => {
    navigate(`/signup?email=${encodeURIComponent(email)}`);
  };
  return (
    <div>
       <HeroSection
        title={
          <>
            Manage Your <br />
            Reputation. Measure <br />
            Customer Experience. <br />
            Maximize Retention.
          </>
        }
        description="Zola is the all-in-one SaaS platform built for home maintenance service providers. Whether you’re a plumber, cleaner, electrician, or landscaper — Zola helps you shine where it matters most: your customers’ feedback."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f651c8f402246755a1b8d3_1.png"
        avatars={[
          "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f65080e1f6e2c564f0c8c0_89d7c3d0050c9da3a82d0ee14a8af2eb_avatar-group-01.png",
          "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f65080e1f6e2c564f0c8be_4a544aed0960c338a8ca5a251a2d05a9_avatar-group-02.png",
          "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f65080e1f6e2c564f0c8bc_0426a0cdcec89efe7bf40db0792fc688_avatar-group-03.png",
          "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f65080e1f6e2c564f0c8ba_bc56222d64587df5971002ce9ff8e5ea_avatar-group-04.png",
          "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f65080e1f6e2c564f0c8b8_d8adda1d69d66ac884204455c36b6bb1_avatar-group-05.png",
        ]}
        rating="5.0"
        reviews="200"
        onSubmit={handleHeroSubmit}
      />
      <InfoSection />
      <ReviewBoostSection />
      <HomeMaintenanceFeatures />
    </div>
  )
}

export default HomeMaintenancePage